async function getCurrentProductInfo(purchase) {
  let urlData = purchase.url;

  let url = "https://" + window.location.host + urlData + ".json";

  return new Promise( async (resolve, reject) => {
    let response = await fetch(url);
    let {product} = await response.json();
    resolve(product); 
  })
}

async function _getSkuInvData(sku) {
  let y = await fetch('https://wigscom-ims.herokuapp.com/variant-inventory-api?sku='+sku, { 
    method: 'get', 
    headers: new Headers({
        'Authorization': 'Bearer nsO_g0TQ2JF9H6DBripCDA', 
        'Content-Type': 'application/x-www-form-urlencoded'
    })
  })
  .then((response) => response.json()).then((data) => data).catch(error => null);
  
  return y;
}

async function getCurrentVariant(purchase) {
  const product = await getCurrentProductInfo(purchase);
  const variant = await getVariantNameCart(product, purchase);
  return variant;
}

function getVariantNameCart(product, purchase) {
  let currentVariantName = purchase.variant_name
  let qtyInCart = purchase.quantity

  const variant = product.variants.filter(v => v.option1 === currentVariantName)[0];
  return variant;
}

function buildMessage(message) {
  return `
    <div class="gap-4">
      <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20">
        <path d="M0 3.75156C0 3.47454 0.224196 3.24997 0.500755 3.24997H10.647C10.9235 3.24997 11.1477 3.47454 11.1477 3.75156V5.07505V5.63362V6.10938V13.6616C10.9427 14.0067 10.8813 14.1101 10.5516 14.6648L7.22339 14.6646V13.6614H10.1462V4.25316H1.00151V13.6614H2.6842V14.6646H0.500755C0.224196 14.6646 0 14.44 0 14.163V3.75156Z"></path>
        <path d="M18.9985 8.08376L11.1477 6.10938V5.07505L19.6212 7.20603C19.8439 7.26203 20 7.46255 20 7.69253V14.1631C20 14.4401 19.7758 14.6647 19.4992 14.6647H17.3071V13.6615H18.9985V8.08376ZM11.1477 13.6616L13.3442 13.6615L13.3443 14.6647L10.5516 14.6648L11.1477 13.6616Z"></path>
        <path d="M7.71269 14.1854C7.71269 15.6018 6.56643 16.75 5.15245 16.75C3.73847 16.75 2.59221 15.6018 2.59221 14.1854C2.59221 12.7691 3.73847 11.6209 5.15245 11.6209C6.56643 11.6209 7.71269 12.7691 7.71269 14.1854ZM5.15245 15.7468C6.01331 15.7468 6.71118 15.0478 6.71118 14.1854C6.71118 13.3231 6.01331 12.6241 5.15245 12.6241C4.29159 12.6241 3.59372 13.3231 3.59372 14.1854C3.59372 15.0478 4.29159 15.7468 5.15245 15.7468Z"></path>
        <path d="M17.5196 14.1854C17.5196 15.6018 16.3733 16.75 14.9593 16.75C13.5454 16.75 12.3991 15.6018 12.3991 14.1854C12.3991 12.7691 13.5454 11.6209 14.9593 11.6209C16.3733 11.6209 17.5196 12.7691 17.5196 14.1854ZM14.9593 15.7468C15.8202 15.7468 16.5181 15.0478 16.5181 14.1854C16.5181 13.3231 15.8202 12.6241 14.9593 12.6241C14.0985 12.6241 13.4006 13.3231 13.4006 14.1854C13.4006 15.0478 14.0985 15.7468 14.9593 15.7468Z"></path>
      </svg>
      ${message}
    </div>
  `;
}

const shipStatus = {
  SIXTEN: 0,
  ONETHREE: 1,
  TWOFIVE: 2,
  TODAY: 3,
  MONDAY: 4,
  TOMORROW: 5,
  PREORDERED: 6,
  IGNORE: 7
}

async function currentVariantData(purchase) {
  let allMessages = [];
  let variant = await getCurrentVariant(purchase);
  let product = await getCurrentProductInfo(purchase);

  let in_stock = false;
  let in_hours = false;
  let is_weekday = false;
  let is_weekday_tmr = false;
  let is_friday = false;
  let ship_msg;
    
  let var_inv_data = await _getSkuInvData(variant.sku);
  
  let qty = await var_inv_data.inventory_quantity;
  let oversell = await var_inv_data.inventory_policy;
  let price = await variant.price;
  let vendor = await product.vendor;

  let currentVariantName = purchase.variant_name;
  let qtyInCart = purchase.quantity;
  let productId;

  if(purchase.id){
    productId = purchase.id.toString();  
  } else if (purchase.url ='/products/free-mystery-gift-gwp') {
     productId = "6975420203119";
  }
  if (qty > 0) {
    in_stock = true;
  }

  let d = new Date();
  if (d.getDay() != 6 && d.getDay() != 0) {
    is_weekday = true;
  }

  if (d.getDay() != 5 && d.getDay() != 6) {
    is_weekday_tmr = true;
  }

  if (d.getDay() == 5 ) {
    is_friday = true;
  }

  let utc = d.getTime() + (d.getTimezoneOffset() * 60000);

  let nd = new Date(utc - 18000000);
  let time = nd.getHours();

  if (time > 0 && time < 16) {
    in_hours = true;
  }

  // Preorder: Find matching line item
  if (document.querySelector(`.product-option[preordered="${variant.id}"]`)) {
    ship_msg = shipStatus.PREORDERED;
    allMessages.push(ship_msg);
  }
  else if (variant.id == "44081111859311") {
    ship_msg = shipStatus.IGNORE;
    allMessages.push(ship_msg);
  }
  else if (qty <= 0 && oversell == 'continue') {
    ship_msg = shipStatus.ONETHREE;
    allMessages.push(ship_msg);

      if (vendor === "TressAllure" 
            || vendor === "BelleTress" 
            || vendor === "Forever Young" 
            || vendor === "Vivica Fox") {
                ship_msg = shipStatus.TWOFIVE;
                allMessages.push(ship_msg)
            }
      if( vendor === "Ellen Wille"){
          ship_msg = shipStatus.SIXTEN;

      }

      if (productId === "1502103208047") {
        ship_msg = shipStatus.TODAY;
        allMessages.push(ship_msg);
      }

      if (productId === "7085355008111") {
        ship_msg = shipStatus.TODAY;
        allMessages.push(ship_msg);
      }
    
  } else if (qty < qtyInCart && oversell == 'continue') {
    ship_msg = shipStatus.ONETHREE;
    allMessages.push(ship_msg);

    if (vendor === "TressAllure" 
            || vendor === "BelleTress" 
            || vendor === "Forever Young" 
            || vendor === "Vivica Fox") {
                ship_msg = shipStatus.TWOFIVE;
                allMessages.push(ship_msg)
            }

             if( vendor === "Ellen Wille"){
               ship_msg = shipStatus.SIXTEN;
              }

  } else if (in_stock && is_weekday && in_hours) {
    ship_msg = shipStatus.TODAY;
    allMessages.push(ship_msg)
  } else if((in_stock && !in_hours && is_friday)|| (in_stock && !is_weekday_tmr)) {
    ship_msg = shipStatus.MONDAY;
    allMessages.push(ship_msg)
  } else if (in_stock && !in_hours) {
    ship_msg = shipStatus.TOMORROW
    allMessages.push(ship_msg)
  } else if (in_stock && !is_weekday && is_weekday_tmr) {
    ship_msg = shipStatus.TOMORROW
    allMessages.push(ship_msg)
  }

  let is_activevariant = purchase.variant_name;

  return ship_msg;
}

function updateFinalShippingMessage(allMessages) {
  let container = document.getElementById('ship-status');

  // Preorder: Cart shipping message
  let messagePrefix = window.customTranslations.yourOrder;

  if (allMessages.includes(shipStatus.PREORDERED)) {
    messagePrefix = window.customTranslations.availableItems;
  }

  if (allMessages.includes(shipStatus.SIXTEN)) {
    msg2 = `${messagePrefix} ${window.customTranslations.willShipInDays6to10}`;
    ship_div = buildMessage(msg2);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  }
  else if (allMessages.includes(shipStatus.TWOFIVE)) {
    msg1 = `${messagePrefix} ${window.customTranslations.willShipInDays2to5}`;
    ship_div = buildMessage(msg1);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.ONETHREE)) {
    msg2 = `${messagePrefix} ${window.customTranslations.willShipInDays1to3}`;
    ship_div = buildMessage(msg2);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.TODAY)) {
    msg3 = `${messagePrefix} ${window.customTranslations.willShipToday}`;
    ship_div = buildMessage(msg3);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.MONDAY)){
    msg4 = `${messagePrefix} ${window.customTranslations.willShipMonday}`;
    ship_div = buildMessage(msg4);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  } else if (allMessages.includes(shipStatus.TOMORROW)){
    msg5 = `${messagePrefix} ${window.customTranslations.willShipTomorrow}`;
    ship_div = buildMessage(msg5);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  } else if (allMessages.every((message) => message === shipStatus.PREORDERED || message === shipStatus.IGNORE)) {
    msg6 = window.customTranslations.backInStock;
    ship_div = buildMessage(msg6);
    container.style.color = "#760F2B"
    container.innerHTML = ship_div
  } 
}

async function getCartContents() {
  let response = await fetch('/cart.js');
  let cart = await response.json();

  let promisedCartProductsInformation = [];
  let allMessages = [];

  for (let item of cart.items) {
    promisedCartProductsInformation.push(new Promise(async (resolve, reject) => {
      if (item.variant_title != null) {
        let purchase = {
          url: item.url.split('?')[0],
          variant_name: item.variant_title,
          quantity: item.quantity,
          id: item.product_id
        };
        
        let currentMessage = await currentVariantData(purchase);
        allMessages.push(currentMessage);
        resolve(currentMessage);
        
      } else {
        let purchase = {
          url: item.url.split('?')[0],
          variant_name: item.variant_options[0],
          quantity: item.quantity 
        };
        let currentMessage = await currentVariantData(purchase);

        allMessages.push(currentMessage);
        
        resolve(currentMessage);
      }
    }))
  }  
  
  Promise.all(promisedCartProductsInformation).then((array) => {
    updateFinalShippingMessage(allMessages);   

    if(allMessages.length === 0) {
      document.getElementById("ship-status").style.display = 'none'
    } else {
      document.getElementById("ship-status").style.display = "flex"
    }
  })
}

setInterval(() => {
  let shipStatusCont = document.getElementById('ship-status');
  if (shipStatusCont.textContent.length < 1) {
    let loading_msg = `<div class="loading__spinner" style="padding-top:3px;">
                        <div class="loading__spinner">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                      </div>`
    shipStatusCont.innerHTML = loading_msg + `<div> ${window.customTranslations.calculating}</div>`;
    getCartContents();     
  }
}, 1000)